module.exports = __webpack_public_path__ + "static/media/logo-nare-cup.3f4f44d0.jpg";